import { features } from './features'; 

features.applicationType = 'fitosgest';
features.showHistoricoFT = false;
features.showVisitas = JSON.parse(localStorage.getItem('melia_user_tag_2') || 'null')
    ? (JSON.parse(localStorage.getItem('melia_user_tag_2') ?? '').nombre === 'ALEJANDRO')
    : false;
features.showMapas = true;
features.empresaName = 'Locatec Aplicaciones Informáticas';
features.showPartida = true;
features.puedeImprimir = true;
features.showRecetaTratamiento = false;
features.showPerfil = false;
features.showEnviarCorreo = true;
features.showFincasInformeTratamientos = true;
features.showMotivoFito = true;

features.adminCanSeeAllRecords = false;
features.showVisitasCamposPersonalizados = true;
features.showTecnicoAsignado = false;

export const environment = {
    production: true,
    v: '2',
    serverUrl: 'https://locatec.es/app-fitosgest/clientes/',
    logoUrl: 'assets/logo_fitogest.png',
    appName: 'melia',
    features: features
};
